/**
 * Reducer for board notes
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import produce from 'immer'
import merge from 'lodash/merge'
import {
  FETCH_BOARD_NOTES_SUCCESS,
  UPDATE_BOARD_NOTES
} from 'client/app/js/services/boards/types'
import {
  GUEST_UPDATE_BOARD_NOTES
} from 'client/app/js/services/guest/types'

export default produce((draft, action) => {
  const { boards } = action.data?.entities ?? []

  switch (action.type) {
    case FETCH_BOARD_NOTES_SUCCESS:
    case UPDATE_BOARD_NOTES:
    case GUEST_UPDATE_BOARD_NOTES:
      merge(draft, boards)
      break
  }
})
